import { environment as devEnvironment } from './environment';
import { environment as prodEnvironment } from './environment.prod';

const env = process.env.REACT_APP_ENV || 'development';

export const config = env === 'production' ? prodEnvironment : devEnvironment;